import React, { Component } from 'react';

const pics = [
    `${process.env.PUBLIC_URL}/media/image/foto_1.jpg`,
    `${process.env.PUBLIC_URL}/media/image/foto_2.jpg`,
    `${process.env.PUBLIC_URL}/media/image/foto_3.jpg`,
    `${process.env.PUBLIC_URL}/media/image/foto_4.jpg`
];

export default class HeroShop extends Component {
    state = { 
        pic: pics[0],
        quantidade: 1 
    }

    render(){
        return (
            <div className="HeroShop">
                <div className="container-big flex vertical">

                    <div>
                        <span>Principal > Informática > Cabos e Adaptadores</span>
                        <br /><br />
                    </div>
                    
                    <div className="flex horizontal">

                        <div className="flex-3 flex horizontal container-pic">
                            <div className="flex-1 flex vertical-ho">
                                {
                                    pics.map((item, idx) => (
                                        <div 
                                            key={idx} 
                                            className="flex-1 flex flex-center link pic-side-container"
                                            onClick={ () => this.setState({ pic: item }) } >
                                            <img alt={`foto do cabo ${idx}`} src={item} className="pic-side" />
                                        </div>
                                    ))
                                }
                            </div>
                            <div className="flex-3 flex flex-center pic-main-container">
                                <img alt={`foto do cabo principal`} src={this.state.pic} className="pic-main" />
                            </div>
                        </div>

                        <div className="flex-2 flex vertical dados-shop">
                            
                            <h2>Cabo para Celular 3 em 1 Feitun</h2>
                            <span className="estrelas" role="img" aria-labelledby="estrelas">⭐️⭐️⭐️⭐️⭐️ (7 avaliações)</span>

                            <h3 className="price"><span>R$</span>7,00</h3>

                            <div className="quantidade">
                                <label>Quantidade</label>
                                <input 
                                    type="number" 
                                    name="quantidade"
                                    value={this.state.quantidade}
                                    onChange={(ev) => ev.target.value > 0 && this.setState({ quantidade: ev.target.value })} />
                            </div>

                            <div className="button-cta">
                                COMPRAR
                            </div>

                            <div className="flex horizontal cards">
                                <div className="flex-1 flex flex-center">
                                    <span className="text-center">FRETE GRÁTIS<br />GUARULHOS*</span>
                                </div>
                                <div className="flex-1 flex flex-center">
                                    <span className="text-center">30 DIAS DE GARATIA<br />CONTRA DEFEITOS</span>
                                </div>
                                <div className="flex-1 flex flex-center">
                                    <span className="text-center">Suporte / SAC<br />(11) 4372-7073</span>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        )
    }
}